module.exports = __webpack_public_path__ + "assets/844977ca9350647ab293c29140ed62ad.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/intro1.mp3
 ** module id = 332
 ** module chunks = 0
 **/